import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { listType } from 'src/app/core/enumerations/enum-ListType';
import { PaginationModel } from 'src/app/core/models/pagination-model';
import { payRequestModel } from 'src/app/core/models/payRequestModel';
import { PublicPortalService } from 'src/app/core/services/public-portal/public-portal.service';


@Component({
  selector: 'app-evaluationlist',
  templateUrl: './evaluationlist.component.html',
  styleUrls: ['./evaluationlist.component.scss']
})
export class EvaluationlistComponent implements OnInit {
  payRequestModel:payRequestModel;
  paginationModel: PaginationModel;
  loggedInUser : any;
  selectedSort:any;
  Records:any;
  totalRecords:any;
  totalPages:number;
  pages= new Array();
  PageNo:number;
  PN:number;
  DropdownRecords: any;
  selectedValue: any;
  isSelected: boolean;
  constructor(
    private service:PublicPortalService,
    private router: Router) { }

  ngOnInit(): void {
    this.paginationModel = new PaginationModel();
    this.payRequestModel=new payRequestModel();
    this.PageNo=Number(this.paginationModel.pageNumber);
    this.GetPayDetailList();
    this.GetPayDropDown();
  }
  clear(){
    this.GetPayDropDown();
    this.GetPayDetailList();
  }
  GetPayDetailList(){

    this.payRequestModel.Type = listType.Evaluations;
    this.payRequestModel.pagination = this.paginationModel;
    this.payRequestModel.pagination.pageSize="10"
    this.service.GetPayDetailList(this.payRequestModel)
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
                 
                  let data = (baseResponse.data as any) ;
                  this.totalPages = data?.totalPages;
                  this.totalRecords = data?.totalRecords;
                  this.pages = new Array();
                  for (let i = 1; i <= this.totalPages; i++) {
                    this.pages.push(i);
                  }
                  this.Records =data?.records;
            }
          }
        }
      })
  }

  changePage(pageNumber){
    
    this.paginationModel.pageNumber = pageNumber;
    this.PageNo=Number(pageNumber);
    this.PN=this.PageNo;
    this.GetPayDetailList();
  }

  nextPage() {
    if (Number(this.paginationModel.pageNumber) < this.totalPages) {
        this.changePage(Number(this.paginationModel.pageNumber) + 1);
      }
  }

  previousPage() {
    if (Number(this.paginationModel.pageNumber) > 1) {
      this.changePage(Number(this.paginationModel.pageNumber) - 1);
    }
  }

  navigate(id)
  {
    this.router.navigateByUrl(`/tenders/evalualtionDetaillist/${id}`);
  }
  selectedPage()
  {
    if(this.PN==null || this.PN==0){
      this.PN=1
    }
    this.paginationModel.pageNumber =String(this.PN);
    this.PageNo=this.PN;
    this.GetPayDetailList();
  }

  onEnterKeyPressed(event: KeyboardEvent): void {
    // Check if the key pressed is Enter
    
    if (event.key === 'Enter') {
      // Call your function here
      this.selectedPage()
    }
  }
  onSelectedValue(){
    
    
    if(this.selectedValue!=null){
     this.payRequestModel.Type = listType.Evaluations;
     this.payRequestModel.pagination = this.paginationModel;
     this.payRequestModel.pagination.pageSize="5000"
     this.payRequestModel.pagination.orderBy = "ASC";
     this.service.GetPayDetailList(this.payRequestModel)
       .subscribe(baseResponse => {
         if (baseResponse != null) {
           if (baseResponse.success != null) {
             if (baseResponse.success) {
                  this.isSelected=true;
                   let data = (baseResponse.data as any) ;
                   this.Records =data?.records.filter(x=>x.OrganizationName==this.selectedValue);
                   this.totalRecords =   this.Records.length;
                   this.totalPages = data?.totalPages;
                   this.pages = new Array();
                   for (let i = 1; i <= this.totalPages; i++) {
                     this.pages.push(i);
                   }
             
             }
           }
         }
       })
     }
     else{
       this.GetPayDetailList();
     }
   }
   GetPayDropDown(){
    this.payRequestModel.Type = listType.Evaluations;
    this.payRequestModel.pagination = this.paginationModel;
    this.payRequestModel.pagination.pageSize="5000"
    //this.payRequestModel.pagination.orderBy = "ASC";
    this.service.GetPayDetailList(this.payRequestModel)
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
                 
                  let data = (baseResponse.data as any) ;
                  this.DropdownRecords =data?.records;
            }
          }
        }
      })
  }
  sort(orderByColumnName, orderBy){
    this.paginationModel.orderBy = orderBy;
    this.payRequestModel.pagination.orderByColumnName = orderByColumnName;
    this.paginationModel.orderByColumnName = orderByColumnName
    this.GetPayDetailList();
  }
}
